import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { AlertTriangle, ArrowRight, Loader2, CheckCircle2 } from "lucide-react";

// FLOOR list of open problem moves — big tap targets, each opens the resolver.
export default function FloorProblems() {
  const [items, setItems] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/problem-moves").then(({ data }) => setItems(data.items || [])).catch(() => setItems([])); }, []);

  if (items === null) return <div className="flex-1 flex items-center justify-center text-slate-400"><Loader2 className="w-10 h-10 animate-spin" /></div>;

  return (
    <div className="flex-1 flex flex-col p-4 sm:p-6 gap-4 overflow-y-auto" data-testid="floor-problems">
      <div className="flex items-center gap-3">
        <AlertTriangle className="w-7 h-7 text-amber-600" />
        <div className="text-3xl font-black tracking-tight">Problem moves</div>
      </div>
      {items.length === 0 ? (
        <div className="flex-1 flex flex-col items-center justify-center gap-3 text-center py-16" data-testid="floor-problems-clear">
          <CheckCircle2 className="w-14 h-14 text-emerald-500" />
          <div className="text-2xl font-black text-emerald-600">All clear</div>
          <button onClick={() => navigate("/floor")} className="text-[#B01E28] font-bold text-xl">Back to scan</button>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((p) => {
            const isZero = p.kind === "zero_parts";
            return (
              <button key={p.id} type="button" data-testid={`floor-problem-row-${p.id}`}
                onClick={() => navigate(`/floor/problem/${p.id}`)}
                className="w-full text-left rounded-2xl border-2 border-[#E2E8F0] bg-white p-4 flex items-center gap-4 active:scale-[0.98] transition-transform">
                <span className={`rounded-lg text-sm font-black uppercase px-3 py-1.5 shrink-0 ${isZero ? "bg-amber-200 text-amber-900" : "bg-red-200 text-red-900"}`}>{isZero ? "0 parts" : "error"}</span>
                <div className="min-w-0 flex-1">
                  <div className="text-xl font-black font-mono truncate">{p.container_code || p.container_scan || "?"}{p.dest_code && <span className="text-slate-400"> → {p.dest_code}</span>}</div>
                  <div className="text-base text-slate-500 truncate">{p.reason}</div>
                </div>
                <ArrowRight className="w-6 h-6 text-slate-300 shrink-0" />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
